var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lms__superadmin_workspaces_edit_services"},[_c('component-title',{attrs:{"size":'medium'}},[_vm._v(_vm._s(_vm.$t('lms.workspace.title.services')))]),_c('form-list-select',{attrs:{"allow-create":false,"labels":[this.$t('lms.workspace.labels.name'), this.$t('lms.workspace.labels.description'), this.$t('lms.workspace.labels.expiryDate'), this.$t('lms.workspace.labels.status')],"name":'service',"items":[
            {
                name: 'EBS',
                description: 'Lorem ipsum',
                expiryDate: '01 Jan 2020',
                status: this.$t('lms.workspace.labels.active')
            },
            {
                name: 'Digital Workbook',
                description: 'Dolor sit amet',
                expiryDate: '01 Jan 2021',
                status: this.$t('lms.workspace.labels.Draft')
            }
        ],"size":'full'}}),_c('pop-notify',{ref:"popnotifyvalidation",class:'pop__notify--validation',attrs:{"title-text":"Something's not quite right","content-text":'Please check that you have filled out all the fields in the form correctly and try again.',"cancel-button-text":'Ok',"submit-button-active":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }